import Configuration from "../../Configuration";

export interface Segment {
    id: string;
    timestamp: number;
    number: string;
    channel: string;
    tsLength: number;
    tsPath: string;
    mp4Path: string;
    jpgPath: string;
    jpgHdPath: string;
    token: string;
}

function getFileURL(channelID: number, file: string, token: string): string {
    const SITE_API_URL = Configuration.get("siteApiURL");
    return `${SITE_API_URL}api/channel/readfile/v1/t/${token}/${channelID}${file}`;
}

function segmentTimeDisplayString(segment: Segment): string {
    const date = new Date(segment.timestamp * 1000);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const hourDisplayStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minuteDisplayStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const secondDisplayStr = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${hourDisplayStr}:${minuteDisplayStr}:${secondDisplayStr}`;
}

function parseHoursString(timestamp: string): number {
    const [hours, minutes, seconds] = timestamp.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}

function parseSecondsString(timestamp: string): number {
    const formattedTimestamp = timestamp.replace("s", "");

    if (formattedTimestamp.includes(":")) {
        const [minutes, seconds] = formattedTimestamp.split(":").map(Number);
        return minutes * 60 + seconds;
    }
    const [seconds, milliseconds] = formattedTimestamp.split(".").map(Number);
    return seconds + (milliseconds ? milliseconds / 1000 : 0);
}

function combineTimestamps(
    livestreamTimestamp: string,
    mouseTimecode: string,
): number {
    const livestreamSeconds = parseHoursString(livestreamTimestamp);
    const mouseSeconds = parseSecondsString(mouseTimecode);
    return livestreamSeconds + mouseSeconds;
}

function formatCombinedTimestamp(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const milliseconds = Math.round((seconds - Math.floor(seconds)) * 1000);

    const pad = (num: number, size: number) => {
        let s = num.toString();
        while (s.length < size) {
            s = `0${s}`;
        }
        return s;
    };

    return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(remainingSeconds, 2)}.${pad(milliseconds, 3)}s`;
}

export {
    getFileURL,
    segmentTimeDisplayString,
    parseHoursString,
    parseSecondsString,
    combineTimestamps,
    formatCombinedTimestamp,
};
